import { PLATFORM, type Platform } from '@/shared/constants';
import type { StoreRecord } from './api';

/**
 * Rows of the stores screen: the stores selected in the top menu, and on the
 * MTM platform only those with MTM front-office access.
 */
export const visibleStores = (
  stores: readonly StoreRecord[],
  platform: Platform,
  selectedIds: readonly (string | number)[],
): StoreRecord[] => {
  const selected = new Set(selectedIds.map(String));
  return stores.filter(
    (store) =>
      (platform !== PLATFORM.DMS || store.frontOfficeAccess?.dms === true) &&
      selected.has(store.id),
  );
};
